import React from 'react';
import MyScheduleFlyout from '@components/mySchedule/MyScheduleFlyout';
import { useNavigationSettings } from '@components/header/useEventNavigationSettings';

interface Props {
  eventId: string;
  navHeight?: number;
  admissionItemId: string;

  // Feature flags
  appointmentsEnabled?: boolean;
  hasSessionList?: boolean;
}

/**
 * Component to determine if the MyScheduleFlyout should be included in the navigation. It
 * reads the navigation configured for the event (hasPublicLandingPage)
 */
function MySchedule({ eventId, appointmentsEnabled, hasSessionList, navHeight, admissionItemId }: Props): JSX.Element {
  const { hasMySchedule } = useNavigationSettings();

  if (!hasMySchedule) return null;

  return (
    <MyScheduleFlyout
      eventId={eventId}
      appointmentsEnabled={appointmentsEnabled}
      hasSessionList={hasSessionList}
      navHeight={navHeight}
      admissionItemId={admissionItemId}
    />
  );
}

export default MySchedule;
